
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Globe } from "lucide-react";

interface SocialMediaCardProps {
  socialFacebook?: string;
  socialInstagram?: string;
  socialYoutube?: string;
  socialTiktok?: string;
  onInputChange: (field: string, value: string) => void;
}

export const SocialMediaCard = ({
  socialFacebook,
  socialInstagram,
  socialYoutube,
  socialTiktok,
  onInputChange,
}: SocialMediaCardProps) => {
  return (
    <Card className="lg:col-span-2">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Globe className="h-5 w-5 text-bobo-green" />
          Social Media Links
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="social_facebook">Facebook URL</Label>
            <Input
              id="social_facebook"
              value={socialFacebook || ""}
              onChange={(e) => onInputChange("social_facebook", e.target.value)}
              placeholder="https://facebook.com/yourpage"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="social_instagram">Instagram URL</Label>
            <Input
              id="social_instagram"
              value={socialInstagram || ""}
              onChange={(e) => onInputChange("social_instagram", e.target.value)}
              placeholder="https://instagram.com/yourpage"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="social_youtube">YouTube URL</Label>
            <Input
              id="social_youtube"
              value={socialYoutube || ""}
              onChange={(e) => onInputChange("social_youtube", e.target.value)}
              placeholder="https://youtube.com/yourchannel"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="social_tiktok">TikTok URL</Label>
            <Input
              id="social_tiktok"
              value={socialTiktok || ""}
              onChange={(e) => onInputChange("social_tiktok", e.target.value)}
              placeholder="https://tiktok.com/@yourpage"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
